<template>

<div class="category">
   <h2 class="title is-2">{{ categoryData.categoryName }}</h2>
   <p class="subtitle is-4">{{ categoryData.categoryDescription }}</p>
   <question v-for="(question, index) in categoryData.data" v-bind:key="index" :questionData="question"  :viewResponses="viewResponses" :lang="lang"/>
</div>

</template>

<script>

import question from "./Question.vue"

export default {
  name: 'Category',
  props: {
    categoryData: Object,
    viewResponses: Boolean,
    lang: String
  },
  components: {
    question: question
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
